import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const styles = {};

export const overrides = {
	'.SimpleCard-root': {
		display: 'flex',
		flexDirection: 'column',
		gap: remCalc(24),
		height: '100%',

		[theme.breakpoints.up('md')]: {
			gap: remCalc(40),
		},

		'.SimpleCard-media': {
			overflow: 'hidden',
			position: 'relative',
			backgroundColor: getColor('ivory', 500),
		},
		'.SimpleCardImage-root, .SimpleCardImage-figure, .SimpleCardImage-pictureContainer, .SimpleCardImage-pictureElement, .SimpleCardImage-fallbackImage': {
			width: '100%',
			height: '100%',
		},
		'.SimpleCardImage-fallbackImage': {
			objectFit: 'cover',
		},
		'.SimpleCard-divider': {
			borderTop: `1px solid ${getColor('ivory', 500)}`,
			width: '100%',
		},
		'.SimpleCard-title': {
			color: getColor('ivory', 700),
			margin: 0,

			'a': {
				color: 'inherit',
				textDecoration: 'none',
				transition: 'color var(--transition-duration) ease-in-out',

				'&:hover, &:focus-visible': {
					color: getColor('ivory', 600),
				},
			},
		},
		'.SimpleCard-intro': {
			color: getColor('ivory', 600),
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(20),
			letterSpacing: remCalc(-0.25),
			lineHeight: remCalc(26),

			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(25),
				lineHeight: remCalc(32),
			},

			'p': {
				margin: 0,

				'&:not(:last-child)': {
					marginBottom: remCalc(4),
				},
			},
			'strong, b': {
				color: getColor('ivory', 700),
				fontWeight: 700,
			},
		},
		'.SimpleCard-cta': {
			color: getColor('ivory', 700),
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(16),
			fontWeight: 420,
			letterSpacing: remCalc(2),
			lineHeight: remCalc(20),
			textDecoration: 'none',
			textTransform: 'uppercase',
			borderBottom: '1px solid transparent',
			alignSelf: 'flex-start',
			transition: 'all var(--transition-duration) ease-in-out',

			'&:hover, &:focus-visible': {
				borderBottomColor: getColor('ivory', 700),
			},
		},
	},
};

export default styles;
